import { gql } from '@apollo/client';
import { getClient } from '../client-graphql';
import { PageLandingFragmentFragment } from '@fm-nx/contentful-types';

export const PageLandingFragment = gql(`
    fragment PageLandingFragment on PageLanding {
        __typename
        sys {
            id
        }
        slug
        pageIntro {
            sys {
                id
            }
        }
    }
`);

type PageLandingQueryResponse = {
    pageLandingCollection?: {
        items: PageLandingFragmentFragment[];
    };
};

export async function getPageLandingBySlug({ slug, preview = false }: { slug: string; preview?: boolean }) {
    const { data } = await getClient(preview).query<PageLandingQueryResponse>({
        query: gql`
            query GetPageLandingBySlug($slug: String!, $preview: Boolean) {
                pageLandingCollection(where: { slug: $slug }, preview: $preview) {
                    items {
                        ...PageLandingFragment
                    }
                }
            }
            ${PageLandingFragment}
        `,
        variables: {
            slug,
            preview,
        },
    });
    return data?.pageLandingCollection?.items?.[0];
}
